import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/contact-us.png'
import _imports_1 from '@/assets/help.png'
import _imports_2 from '@/assets/faq.png'


const _withScopeId = n => (_pushScopeId("data-v-63757a38"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "swipe-stepper" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "swipe-stepper-main" }
const _hoisted_4 = {
  class: "nav-bar",
  id: "menu-container"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "btn-nav-previous" }, "   ", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "btn-nav-next" }, "     ", -1))
const _hoisted_7 = {
  class: "menu-inner-box",
  ref: "menuInnerBox"
}
const _hoisted_8 = ["id", "onClick"]
const _hoisted_9 = ["id"]
const _hoisted_10 = { class: "buttons" }
const _hoisted_11 = { class: "buttons-sml" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "logo",
  src: _imports_0
}, null, -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "logo",
  src: _imports_1
}, null, -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "logo",
  src: _imports_2
}, null, -1))
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))

export function render(_ctx, _cache) {
  const _component_HelpScreen = _resolveComponent("HelpScreen")

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _hoisted_6,
          _createElementVNode("ul", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.navSteps, (s, index) => {
              return (_openBlock(), _createElementBlock("li", {
                id: s.status,
                onClick: _withModifiers($event => {_ctx.navigate(s);}, ["prevent","stop"]),
                class: _normalizeClass([s.status, !s.visible ? 'hide' : ''])
              }, [
                _createElementVNode("span", {
                  id: s.routeSecName
                }, _toDisplayString(s.name), 9, _hoisted_9)
              ], 10, _hoisted_8))
            }), 256))
          ], 512)
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("button", {
            class: "btn btn-outline sml",
            onClick: _cache[0] || (_cache[0] = $event => (_ctx.contactUs()))
          }, "Contact Us"),
          (_ctx.showHelpBtn && _ctx.helpContent?.isShow)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "btn btn-outline sml",
                onClick: _cache[1] || (_cache[1] = $event => (_ctx.showHelpScreen = !_ctx.showHelpScreen))
              }, "Help"))
            : _createCommentVNode("", true),
          (_ctx.showFaqBtn)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                class: "btn btn-outline sml",
                onClick: _cache[2] || (_cache[2] = $event => (_ctx.faqLink()))
              }, "FAQ"))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("span", {
            onClick: _cache[3] || (_cache[3] = $event => (_ctx.contactUs())),
            title: "Contact us"
          }, _hoisted_13),
          (_ctx.showHelpBtn && _ctx.helpContent?.isShow)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                onClick: _cache[4] || (_cache[4] = $event => (_ctx.showHelpScreen = !_ctx.showHelpScreen)),
                title: "Help"
              }, _hoisted_15))
            : _createCommentVNode("", true),
          (_ctx.showFaqBtn)
            ? (_openBlock(), _createElementBlock("span", {
                key: 1,
                onClick: _cache[5] || (_cache[5] = $event => (_ctx.faqLink())),
                title: "FAQ"
              }, _hoisted_17))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    (_ctx.showHelpScreen)
      ? (_openBlock(), _createBlock(_component_HelpScreen, {
          key: 0,
          onClose: _cache[6] || (_cache[6] = $event => (_ctx.showHelpScreen = false)),
          helpContent: _ctx.helpContent
        }, {
          header: _withCtx(() => [
            _hoisted_18
          ]),
          body: _withCtx(() => []),
          _: 1
        }, 8, ["helpContent"]))
      : _createCommentVNode("", true)
  ]))
}